<template>
  <Modal @close="$emit('close')">
    <template #header>
      {{ $t('HeadContract.VariationsSchedule.VariationShowModal.backChargeModal.title') }}
    </template>

    <template #body>
      <form class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">
            {{ $t('HeadContract.VariationsSchedule.VariationShowModal.backChargeModal.targetPackage') }}
          </label>

          <select
            v-model="targetPackageId"
            class="form-input w-full"
          >
            <option
              :value="undefined"
              disabled
            >
              {{ $t('HeadContract.VariationsSchedule.VariationShowModal.backChargeModal.selectPackage') }}
            </option>

            <option
              v-for="targetPackage in targetPackages"
              :key="targetPackage.id"
              :value="targetPackage.id"
            >
              {{ targetPackage.name }}
              <template v-if="targetPackage.subcontractor">
                ({{ targetPackage.subcontractor.name }})
              </template>
            </option>
          </select>
        </div>
      </form>
    </template>

    <template #footer>
      <button
        type="button"
        class="btn btn--ghost-default"
        :disabled="backChargeAction.loading.value"
        @click="$emit('close')"
      >
        {{ $t('HeadContract.VariationsSchedule.VariationShowModal.button.close') }}
      </button>

      <button
        type="button"
        class="btn btn--primary-blue"
        :disabled="!targetPackageId || backChargeAction.loading.value"
        @click="backCharge"
      >
        {{ $t('HeadContract.VariationsSchedule.VariationShowModal.backChargeModal.confirm') }}
      </button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import Modal from '@/components/Modal.vue';
import { useStoreApiAction } from '@/composables/useStoreApiAction';
import VariationOrder from '@/models/VariationOrder';
import { usePackagesStore } from '@/store/packages';
import { useProjectsStore } from '@/store/projects';
import { useVariationOrdersStore } from '@/store/variationOrders';
import Swal from 'sweetalert2';
import { computed, onMounted, ref } from 'vue';

const props = defineProps<{
  variationOrder: VariationOrder;
}>();

const emit = defineEmits<{
  close: [];
  'back-charged': [];
}>();

const projectsStore = useProjectsStore();
const packagesStore = usePackagesStore();
const variationOrdersStore = useVariationOrdersStore();
const backChargeAction = useStoreApiAction(variationOrdersStore.backChargePackageVariationOrder);
const targetPackageId = ref<number | undefined>();
const project = computed(() => projectsStore.project);

const targetPackages = computed(() => {
  return packagesStore.models
    .where('project_id', project.value?.id)
    .with('subcontractor')
    .get()
    .filter((targetPackage) => targetPackage.id !== props.variationOrder.package_id);
});

const backCharge = async () => {
  if(
    !targetPackageId.value || !project.value?.id || !props.variationOrder.package_id || backChargeAction.loading.value
  ) {
    return;
  }

  backChargeAction.request(
    project.value.id,
    props.variationOrder.package_id,
    props.variationOrder.id,
    {
      target_package_id: targetPackageId.value,
    },
  ).then(() => {
    Swal.fire({ icon: 'success', title: 'Variation order back charged' });
    emit('back-charged');
    emit('close');
  });
};
</script>
